module.exports = __webpack_public_path__ + "img/wallpapers.svg.905cb3cc.webp";